import React from 'react';

export const AnnuaireSiteTab = ({ data, setData }) => {
  const addSite = React.useCallback(() => {
    setData(prev => ({
      ...prev,
      annuaireSite: {
        ...prev.annuaireSite,
        sites: [...(prev.annuaireSite?.sites || []), {
          id: Date.now(),
          nom: '',
          type: '',
          adresse: '',
          codePostal: '',
          ville: '',
          telephone: '',
          responsable: '',
          email: '',
          notes: ''
        }]
      }
    }));
  }, [setData]);

  const updateSite = React.useCallback((index, field, value) => {
    setData(prev => {
      const updatedSites = [...(prev.annuaireSite?.sites || [])];
      updatedSites[index] = {
        ...updatedSites[index],
        [field]: value
      };
      return {
        ...prev,
        annuaireSite: {
          ...prev.annuaireSite,
          sites: updatedSites
        }
      };
    });
  }, [setData]);

  const removeSite = React.useCallback((index) => {
    setData(prev => ({
      ...prev,
      annuaireSite: {
        ...prev.annuaireSite,
        sites: (prev.annuaireSite?.sites || []).filter((_, i) => i !== index)
      }
    }));
  }, [setData]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-blue-700">Annuaire des Sites</h3>
        <button
          onClick={addSite}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          + Ajouter un site
        </button>
      </div>

      {data.sites && data.sites.length > 0 ? (
        <div className="space-y-4">
          {data.sites.map((site, index) => (
            <div key={site.id || index} className="border border-gray-200 rounded-lg p-6 bg-gray-50">
              <div className="flex justify-between items-start mb-4">
                <h4 className="text-lg font-medium text-gray-800">Site {index + 1}</h4>
                <button
                  onClick={() => removeSite(index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nom du site
                  </label>
                  <input
                    type="text"
                    value={site.nom || ''}
                    onChange={(e) => updateSite(index, 'nom', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Type d'établissement
                  </label>
                  <select
                    value={site.type || ''}
                    onChange={(e) => updateSite(index, 'type', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Sélectionner un type</option>
                    <option value="hopital">Hôpital</option>
                    <option value="clinique">Clinique</option>
                    <option value="ehpad">EHPAD</option>
                    <option value="cabinet">Cabinet médical</option>
                    <option value="centre_sante">Centre de santé</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Adresse
                  </label>
                  <input
                    type="text"
                    value={site.adresse || ''}
                    onChange={(e) => updateSite(index, 'adresse', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Code postal
                    </label>
                    <input
                      type="text"
                      value={site.codePostal || ''}
                      onChange={(e) => updateSite(index, 'codePostal', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Ville
                    </label>
                    <input
                      type="text"
                      value={site.ville || ''}
                      onChange={(e) => updateSite(index, 'ville', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Téléphone
                  </label>
                  <input
                    type="tel"
                    value={site.telephone || ''}
                    onChange={(e) => updateSite(index, 'telephone', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Responsable du site
                  </label>
                  <input
                    type="text"
                    value={site.responsable || ''}
                    onChange={(e) => updateSite(index, 'responsable', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email de contact
                  </label>
                  <input
                    type="email"
                    value={site.email || ''}
                    onChange={(e) => updateSite(index, 'email', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Notes / Informations complémentaires
                  </label>
                  <textarea
                    value={site.notes || ''}
                    onChange={(e) => updateSite(index, 'notes', e.target.value)}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-gray-500 mb-4">Aucun site enregistré</p>
          <button
            onClick={addSite}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Ajouter le premier site
          </button>
        </div>
      )}
    </div>
  );
};